<template>
    <section class="section">
        <div class="hero">
            <div class="hero-head has-text-centered">
                <h1 class="title is-1">{{deployment.name}}</h1>
            </div>
        </div>
        <br>
        <div class="container" :class="{'box': isDesktop}">
            <div>
                <h3 class="title is-3">Combined Statistics:</h3>
                <amount-table :amounts="deployment.totals"></amount-table>
            </div>
            <hr>
            <div>
                <h3 class="title is-3">Sessions:</h3>
                <div v-for="(date, index)  in deployment.days" :v-key="date.toISOString() + index" class="media">
                    <div class="media-left">{{ date.format('MMM D, YYYY') }}</div>
                    <div class="media-content" style="overflow-x: auto;">
                        <table class="table is-hidden-mobile">
                            <thead>
                                <tr>
                                    <th>Session</th>
                                    <th v-for="key of Object.keys(deployment.getTotalsForDay(date))" :key="date.toISOString() + index + key">
                                        {{ key }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>
                                        <span class="never-wrap">Total</span> <span class="never-wrap">(for day)</span>
                                    </th>
                                    <th v-for="value of deployment.getTotalsForDay(date)" :key="date.toISOString() + value">
                                        <span v-if="false">Relying on getTotalsForDay to return key, value pairs in the same order</span>
                                        {{ value }}
                                    </th>
                                </tr>
                                <tr v-for="(session, index) in deployment.getSessionsForDay(date)" :v-key="session.permanent_id + index">
                                    <th>
                                        <span class="never-wrap">{{edarById(session.edar_id).baseName}}</span>
                                        <span class="is-hidden-touch is-hidden-desktop-only">at</span>
                                        <span class="never-wrap">{{session.start.format('h:mm a')}}</span>
                                    </th>
                                    <td v-for="key of Object.keys(deployment.getTotalsForDay(date))" :key="session.permanent_id + date.toISOString() + index + key">
                                        <span v-if="false">Relying on getTotalsForDay to return key, value pairs in the same order</span>
                                        {{ session.amounts[key] }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="is-hidden-tablet">
                            <strong>Per Day Totals</strong>
                            <amount-table :amounts="deployment.getTotalsForDay(date)"></amount-table>
                            <div v-for="(session, index) in deployment.getSessionsForDay(date)" :v-key="session.permanent_id + index" class="media">
                                <div class="media-content">
                                    <strong>{{edarById(session.edar_id).baseName}} at {{session.start.format('h:mm a')}}</strong>
                                    <amount-table :amounts="session.amounts"></amount-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {isSize} from "../../../mixins";
    import { mapGetters } from "vuex";
    import AmountTable from "./AmountTable";

    export default {
        name: "DeploymentDetail",
        components: {AmountTable},
        mixins: [isSize],
        props: {
            deploymentId: {
                type: [String, Number],
                required: true,
            },
        },
        computed: {
            //Pull the specific Deployment we're interested in out of the store
            deployment() {
                return this.$store.getters['deployment/byId'](this.deploymentId);
            },
            ...mapGetters('edar', {
                edarById: 'byId' //Returns an Edar object
            }),
        },
        methods: {

        },
        beforeRouteEnter(to, from, next){
            let deployment = window.app.$store.getters['deployment/byId'](to.params.deploymentId);
            to.meta.breadcrumb = `${deployment}`;
            next();
        },
        beforeRouteUpdate(to, from, next){
            let deployment = this.$store.getters['deployment/byId'](to.params.deploymentId);
            to.meta.breadcrumb = `${deployment}`;
            next();
        },
    }
</script>

<style scoped>
.never-wrap {
    white-space: nowrap;
}
</style>